import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS types
import { RootState } from '@redux/store';
import { Area, IPlanList_Format } from '@redux/common';

// component
import Plan from '@component/Normal/Plan'; // 各項清單明細

// styles
import '../CommonStyles/Plans.scss';

// common function
import { MapItems, getErrMsg } from '@libs/core';

// plugin
import { useTranslation } from 'react-i18next';

// redux actions
import { 
    setRestore,
    setTicketErrorMsg,
    setCalendarErrorMsg,
    setSessionErrorMsg,
} from '@redux/Normal/actions';
import { setTRestore } from '@redux/NormalT/actions';
import { setTHSROpenedPanel } from '@redux/THSR/actions';
import { setDetailFetchFailMsg } from '@redux/Common/actions';

interface ListPanelProps {
 // TODO: 有時間再定義
    isCrossell?: boolean
}

const ListPanel: React.FC<ListPanelProps> = (props) => {
    const { isCrossell } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { THSROpenedPanel } = useSelector((state: RootState) => state.THSR);
    const { 
        NowListID,
        ticketErrorMsg,
        sessionErrorMsg,
        calendarErrorMsg,
    } = useSelector((state: RootState) => state.Normal);
    const { ListData, focusArea, DetailFetchFailMsg } = useSelector((state: RootState) => state.Common);

    // 切換面板時行為設定
    useEffect(() => {
        if (NowListID && focusArea === Area.THSR) {
            dispatch(setRestore());
        }
        if (THSROpenedPanel && focusArea === Area.Origin) {
            dispatch(setTHSROpenedPanel(''));
            dispatch(setTRestore());
        }
        ticketErrorMsg && dispatch(setTicketErrorMsg(''));
        calendarErrorMsg && dispatch(setCalendarErrorMsg(''));
        sessionErrorMsg && dispatch(setSessionErrorMsg(''));
        DetailFetchFailMsg && dispatch(setDetailFetchFailMsg(null)); // 打開方案前先重置提示
    }, [dispatch, NowListID, focusArea, THSROpenedPanel, calendarErrorMsg, ticketErrorMsg, sessionErrorMsg]);

    // const _Format = useMemo(() => {
    //     if (!THSRInitData?.HasTHSR) return ListData.Format;
    //     return MapItems({ listItems: ListData.Format });
    // }, [ListData.Format, THSRInitData?.HasTHSR]);

    // list分類有無FormatID 
    // const getRenderList = (formatList: IPlanList_Format[]) => {
    //     const newList = []
    //     let defaultCount = 0
    //     for(let i = 0; i < formatList.length; i++){
    //         if(formatList[i].FormatID === "Default"){ // 無ID的產品只要取第一筆
    //             if (defaultCount !== 0) continue;
    //             newList.push(formatList[i])
    //             defaultCount++;
    //         } else {
    //             newList.push(formatList[i])
    //         }
    //     }
    //     return newList
    // }
    return (
        <>
            {ListData?.Format ? 
            ( 
                ListData.Format.length !== 0 ? // 若只有綁高鐵的方案，Format就是空陣列
                    (
                        ListData.Format.map((list, index) =>
                        <Plan
                            key={list.FormatID}
                            data={list}
                            Currency={ListData.Currency}
                            SaleCurrency={ListData.SaleCurrency}
                            listIndex={index}
                            isCrossell={isCrossell}
                        />)
                    ) : (
                        null
                    )
            ) : (
                <div>{t('common.noListFormat')}</div>
            )}
        </>
    );
};

export default ListPanel;